exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-bulk-action-container .bulk-action-btn[data-v-5bbb69ba] {\n  width: 180px;\n}\n.md-button-custom-ready-for-packing[data-v-5bbb69ba] {\n  background: #1c3e61 !important;\n  color: #fff !important;\n}\n", ""]);

// exports
